import { render, staticRenderFns } from "./AddBillItemsSearch.vue?vue&type=template&id=66633f6f"
import script from "./AddBillItemsSearch.vue?vue&type=script&setup=true&lang=js"
export * from "./AddBillItemsSearch.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports